var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetterMailNotificationGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Interface, Essential/letter-mail-notification"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M17.5028 9.16639V13.3348C17.5028 14.7161 16.3831 15.8358 15.0018 15.8358H4.99762C3.61634 15.8358 2.49658 14.7161 2.49658 13.3348V6.66535C2.49658 5.28406 3.61634 4.16431 4.99762 4.16431H12.5007",
    stroke: "#098E1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7372 3.33057C16.1164 3.32912 15.5421 3.65942 15.2313 4.19674C14.9204 4.73407 14.9203 5.39654 15.231 5.93396C15.5417 6.47139 16.1158 6.80188 16.7366 6.80063H16.7372C17.3579 6.80209 17.9322 6.47179 18.243 5.93446C18.5539 5.39714 18.554 4.73467 18.2433 4.19724C17.9326 3.65981 17.3585 3.32932 16.7377 3.33057H16.7372Z",
    stroke: "#098E1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M14.168 8.1484L11.2676 10.4073C10.447 11.0465 9.29291 11.0313 8.48951 10.3706L4.99756 7.49902",
    stroke: "#098E1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterMailNotificationGreen);
export default __webpack_public_path__ + "static/media/letter-mail-notification-green.2d90eecef650a040e72a399db06506c8.svg";
export { ForwardRef as ReactComponent };